import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import icons from "./iconUndSDGoalsList";
import { useTranslation } from "react-i18next";
import LoadingButton from "@mui/lab/LoadingButton";
import DialogConfirmWrapper from "components/DialogConfirmWrapper";

const UndSDGoalsDialog = ({ open, onClose, onSave, initialSelected = [] }) => {
  const [selected, setSelected] = useState(initialSelected);
  const { t } = useTranslation();

  const toggleSelect = (goal) => {
    setSelected((prev) =>
      prev.includes(goal)
        ? prev.filter((item) => item !== goal)
        : [...prev, goal]
    );
  };

  const handleSave = () => {
    onSave(selected);
    onClose();
  };

  useEffect(() => {
  if (open) {
    setSelected(initialSelected); 
  }
}, [open, initialSelected]);

  return (
    <DialogConfirmWrapper
      openPopup={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "1100px",
          height: "900px",
          maxWidth: "none",
        },
      }}
      titleMessage={t("labels.un_sdg_goals")}
      popupMessage={
        <>
          <Grid
            container
            sx={{
              padding: 1,
              
              display: "flex",
              flexWrap: "wrap",
              gap: "16px", 
              justifyContent: "flex-start",
            }}
          >
            {icons.map((icon) => {
              const isSelected = selected.includes(icon.id);
              return (
                <Grid
                  key={icon.id}
                  item
                  mt={1}
                  sx={{
                    flex: "0 0 calc(20% - 16px)", // 20% menos o gap para caber 5 por linha
                    textAlign: "center",
                    cursor: "pointer",
                    boxSizing: "border-box",
                  }}
                  onClick={() => toggleSelect(icon.id)}
                >
                  <img
                    src={icon.file}
                    alt={icon.name}
                    style={{
                      width: "80%",
                      display: "block",
                      margin: "0 auto",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      filter: isSelected ? "none" : "grayscale(1)",
                      transition: "filter 0.3s ease",
                      borderRadius: "7px",
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        </>
      }
      confirmLabel={t("labels.confirm")}
      onConfirm={handleSave}
    />
  );
};

export default UndSDGoalsDialog;
